export enum PlanEverplansPaymentType {
	EFT = 'EFT',
	CreditCard = 'Credit Card',
}
